import HeroJewelry from 'shared/lib/assets/img/landing/hero-jewelry.png';
import LogoMarkel from 'shared/lib/assets/img/logo/logo-markel.svg';

export const jewelryConfig = {
  hero: {
    heading: 'Standing Watch: Protection for your fine jewelry and watches',
    subheading:
      'They’re more than arm candy: Your fine jewelry and watches tell a story—and will continue to be cherished for generations to come.',
    cta: 'Get jewelry & Watch insurance',
    ctaLink: '/collectibles/jewelry-insurance/start',
    img: HeroJewelry,
  },
  underwriter: {
    img: LogoMarkel,
    name: 'Markel',
  },
  coverageDetails: [
    {
      heading: 'Theft',
      subheading:
        'Your heart may be broken after the theft of your jewelry—but your property will be covered.',
    },
    {
      heading: 'Coverage Beyond Basics',
      subheading:
        'A specialized policy does what homeowners’ insurance doesn’t: Covers the escalated costs of repair and replacement for your fine jewelry and watches.',
    },
    {
      heading: 'Damages',
      subheading:
        'When your jewelry and watches are damaged, you’ll need a specialist to work their magic. With this policy, it’s covered.',
    },
    {
      heading: 'Insurance En Route',
      subheading:
        "This policy covers you from the moment of purchase, whether you're shipping an item to your home or transporting it yourself.",
    },
  ],
  scenarioDetails: {
    heading: 'Why Would You Need Fine Jewelry and Watch Insurance?',
    scenarios: [
      {
        heading: 'Scenario 1',
        subheading: 'You lose one of your earrings in an accident.',
      },
      {
        heading: 'Scenario 2',
        subheading: 'You lose one of your earrings in an accident.',
      },
      {
        heading: 'Scenario 3',
        subheading: 'You lose one of your earrings in an accident.',
      },
      {
        heading: 'Scenario 4',
        subheading: 'You lose one of your earrings in an accident.',
      },
    ],
  },
  comparison: [
    'Instant quote',
    'Buy and manage your policy in one place',
    'Insurance explained in simple, easy-to-digest way',
    'Mobile',
    'Endorsements',
    'Plan tailored to fit your needs',
  ],
};
